import { createDecorator } from '../../instantiation/common/instantiation.js';
export * from '../../../base/parts/quickinput/common/quickInput.js';
export const IQuickInputService = createDecorator('quickInputService');



//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/platform/quickinput/common/quickInput.js
// module id = null
// module chunks = 